<template>
  <div class="task_pop_bg">
    <!-- 标题 -->
    <div class="topBorder">
    </div>
    <div class="titleLine">
      <div class="info_title">
        <div class="titleLine_name"><span class="leftLine"></span><span>{{getEarlymsg.typeName}}</span></div>
        <div class="closeBtn" @click="close"></div>
      </div>  
    </div>
    <div class="middleOutLine" style="width:100%;overflow:hidden;padding:0 10px;" v-if="!isLookDetail">
        <div class="topLine">
            <div>
                <span>时间:{{getEarlymsg.dataTime}}</span>
                <span>来源:{{getEarlymsg.sourceName}}</span>
            </div>
            <div>等级：<span class="redLevel">{{getEarlymsg.levelName}}</span></div>
        </div>
        <div class="lookDetail" @click="lookDetails">查看详情</div>
    </div>
    <div class="bottomBorder"></div>
  </div>
</template>
<script>
import MyApis from "../../../apis";
import ZJApp from "../../../../../app";
import waitAll from "../../../../../../utils/src/waitAll";
import { mapGetters,mapState,mapActions} from 'vuex';
export default {
  data() {
    return {
       isLookDetail:false,
        ruleForm: {
        Title: "",
        finishTime: "",
        content:"",
        date: [],
        Summary: "",
        Description: "",
        checkList: [],
        IsPublish: "",
        address:"",
        zeUser:""
      },
      rules: {
        Title: [{ required: true, message: "请输入标题", trigger: "blur" }],
        date: [{ required: true, message: "请输入有效期", trigger: "blur" }],
        Description: [
          { required: true, message: "请输入内容描述", trigger: "blur" },
        ],
      },
      IsEdit: false,
      dialogImageUrl: "",
      dialogVisible: false,
      disabled: false,
      imgList: [],
      fileList: [],
      delFileList: [],
      currentValue: "",
      preValue: "",
    };
  },
   computed: {
      httpRequest() {
      return ZJApp.ZJApis.ZJUploader.upload;
     },
    ...mapState({
        'getEarlymsg':state => state.earlyMsg
     }),
  },
  watch:{
   'getEarlymsg':function(val){
     console.log(val)
   }
  },
  created: function() {
  },
  mounted: function() {
    console.log(this.getEarlymsg)
  },
  methods: {
    ...mapActions(["submitMsgTask"]),
    close(){
        this.$emit("closeEquipMent",false)
    },
    handleREngong(){
        this.$emit("handleREN",false)
    },
    handleTask(){
      this.submitMsgTask(true)
      this.$emit("handleTask",false)
    },
    lookDetails(){
      let msg = this.getEarlymsg;
      // this.isLookDetail = !this.isLookDetail;
       this.$emit("lookMsgDetail",String(msg.id));
    },
     handleRemove(file, fileList) {
      // console.log(file);
      // console.log(fileList)
      // console.log(this.fileList)
      let that = this;
      if (file.FileUrl) {
        // 最后提交的时候再删除
        this.delFileList.push(file);
        this.fileList.forEach((item) => {
          if (item.FileUrl == file.FileUrl) {
            item.Validity = 0;
          }
        });
      }
      let arr = [];
      fileList.forEach((item) => {
        if (that.$route.query.type == "edit") {
          if (!item.FileUrl) {
            arr.push(item.raw);
          }
        } else {
          arr.push(item.raw);
        }
      });
      this.imgList = arr;
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    uploadAvatar(item) {
      this.imgList.push(item.file);
      // console.log("this.imgList")
      // console.log(this.imgList)
      // console.log(this.fileList)
    },
    // 弹出一个错误消息
    errmsg(msg) {
      this.$message({
        showClose: true,
        message: msg || "",
        type: "error",
        customClass: "zj-login-msgbox",
      });
    },
    search() {
      let InfoId = this.$route.query.InfoId;
      if (InfoId) {
        let searchInfo = {
          InfoId: InfoId,
          PageSize: 20,
          PageIndex: 1,
          TotalCount: 0,
          StartNumber: 0,
          EndNumber: 0,
        };
        new MyApis.TranResourcesApi()
          .GetItemById(searchInfo)
          .then((r) => {
            r = r.data.Data;
            console.log(r);
            r.checkList = r.PublishChannel.split("|");

            let arr = [];
            arr.push(r.EffectiveFrom);
            arr.push(r.EffectiveTo);
            r.date = arr;
            this.ruleForm = r;
            this.preValue = this.ruleForm.Description
            this.ruleForm.IsPublish = this.ruleForm.IsPublish + "";
            // console.log("this.ruleForm")
            // console.log(this.ruleForm)
            // this.imgList = r.InfoAttachmentDTOList;
            this.fileList = r.InfoAttachmentDTOList;
            this.fileList.forEach((item) => {
              item.url = item.FileUrl;
              item.name = item.FileName;
            });
          })
          .catch((e) => {
            console.log(e);
            this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
          });
      }
    },
    //返回按钮
    onBack() {
      this.$router.go(-1); //返回上一层
    },
    save() {
      let that = this;
      let uuid = ZJApp.ZJUtils.uuid();
      //先上传图片
      that.uploadAttch(uuid).then((r) => {
        // console.log("图片结果")
        // console.log(r)
        that.saveData(r);
      });
    },
    saveData(r) {
      let PublishChannel = this.ruleForm.checkList.join("|");
      this.ruleForm.PublishChannel = PublishChannel;
      this.currentValue = this.ruleForm.Description;
      // 图片的infoID和信息的infoID一样
      let uuid = "";
      if (this.$route.query.type == "edit") {
        uuid = this.$route.query.InfoId;
      } else {
        uuid = ZJApp.ZJUtils.uuid();
      }

      let InfoAttachmentDTOList = [];
      let deptId =
        ZJApp.ZJUser.current.Departments.length > 0
          ? ZJApp.ZJUser.current.Departments[0].OrgId
          : "error-no-department";

      // console.log("this.ruleForm")
      // console.log(this.ruleForm)

      //如果有图片
      if (r && r.length > 0) {
        r.forEach((item) => {
          let obj = {
            Id: item.ID,
            Validity: 1,
            // "Extend1":"",
            // "Extend2":"",
            // "Extend3":"",
            OrgId: deptId,
            // "AttachmenetId": ZJApp.ZJUtils.uuid(),
            InfoId: uuid,
            FileName: item.FileName,
            FileUrl: item.DownloadPath,
            FileType: item.Extension,
            FileId: item.FileID,
            Creater: item.Creater,
            CreateTime: item.CreateTime,
            Modifier: item.Modifier,
            ModifyTime: item.ModifyTime,
          };
          InfoAttachmentDTOList.push(obj);
        });

        if (this.$route.query.type == "edit") {
          let arr = [];
          this.ruleForm.InfoAttachmentDTOList = arr.concat(
            this.fileList,
            InfoAttachmentDTOList
          );
        } else {
          this.ruleForm.InfoAttachmentDTOList = InfoAttachmentDTOList;
        }
      }
      this.ruleForm.EffectiveFrom = this.ruleForm.date[0];
      this.ruleForm.EffectiveTo = this.ruleForm.date[1];

      if (this.$route.query.type == "edit") {
        //编辑
        this.ruleForm.ModifyTime = new Date();
        this.ruleForm.Modifier = ZJApp.ZJUser.current.UserName;
        this.ruleForm.IsPublish = Number(this.ruleForm.IsPublish);
        delete this.ruleForm.date;
        delete this.ruleForm.checkList;
        delete this.ruleForm.imgUrl;
        let formAll = this.ruleForm;
        new MyApis.TranResourcesApi()
          .UpdateItem(formAll)
          .then((r) => {
            r = r.data.Data;
            this.$message({
              type: "success",
              message: r ? "保存成功！" : "保存失败！",
            });
            this.logInfo.ActionName = "公告管理修改";
            this.logInfo.LogMessage = "公告管理修改成功";
            this.logInfo.ModuleName = "公告管理";
            this.logInfo.PageName = "公告管理详情";
            this.logInfo.PreValue = this.preValue;
            this.logInfo.CurrentValue = this.currentValue; 
            this.addOperationLog();
            this.$router.go(-1); //返回上一层
          })
          .catch((e) => {
            console.log(e);
            this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
          });
      } else {
        // 增加
        let formObj = {
          Creater: ZJApp.ZJUser.current.UserName,
          CreateTime: new Date(),
          Modifier: ZJApp.ZJUser.current.UserName,
          ModifyTime: new Date(),
          Validity: 1, //新增编辑是1，删除是0
          OrgId: deptId,
          InfoId: uuid,
        };
        this.ruleForm.IsPublish = Number(this.ruleForm.IsPublish);
        delete this.ruleForm.date;
        delete this.ruleForm.checkList;
        delete this.ruleForm.imgUrl;
        let formAll = Object.assign(formObj, this.ruleForm);
        new MyApis.TranResourcesApi()
          .AddItem(formAll)
          .then((r) => {
            r = r.data.Data;
            this.$message({
              type: "success",
              message: r ? "保存成功！" : "保存失败！",
            });
            this.logInfo.ActionName = "公告添加";
            this.logInfo.LogMessage = "公告添加成功";
            this.logInfo.ModuleName = "公告管理";
            this.logInfo.PageName = "公告管理详情";
            this.logInfo.CurrentValue = this.currentValue; 
            this.addOperationLog();
            this.$router.go(-1); //返回上一层
          })
          .catch((e) => {
            console.log(e);
            this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
          });
      }
    },
    //保存
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.save();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
      //this.$router.go(-1); //返回上一层
    },
    //插入附件
    uploadAttch(feedid) {
      return new Promise((resolve, reject) => {
        let mediaList = this.imgList;
        var arr = [];
        mediaList.forEach((item) => {
          var option = {
            file: item,
            data: {
              module: "unifiedRelease", //模块名
              submodule: "Announcement", //子模块
              assocID: feedid, //业务ID
              uploader: ZJApp.ZJUser.current.UserName, //上传人
            },
            onProgress: () => {},
            onSuccess: () => {},
            onError: () => {},
          };
          arr.push(this.httpRequest(option));
        });

        waitAll(arr)
          .then((r) => {
            resolve(r);
          })
          .catch((e) => {
            reject(e);
          });
      });
    },
  }
};
</script>
<style scoped lang="scss">
  .task_pop_bg{
    width:36.5%;
    position: fixed;
    left:50%;
    top:180px;
    z-index: 10000;
    margin-left:-18.2%;
    box-sizing: border-box;
    overflow: hidden;
    border-bottom-left-radius: 22px;
    .topBorder{
      width:100%;
      height:34px;
      background: url("../../../../../../assets/pop_tz.png") no-repeat;
      background-size: 100% 34px;
      position:relative;
    }
    .bottomBorder{
      width:100%;
      height:25px;
      background: url("../../../../../../assets/pop_bz.png") no-repeat;
      background-size: 100%;
    }
    .titleLine{
      width:100%;
      box-sizing: border-box;
      background:rgba(15,36,69,0.8);
      border-left: 1px solid #2ac1ff;
      border-right: 1px solid #2ac1ff;
      padding-bottom: 10px;    
      .info_title{  
        width:92%;
        margin:0 auto;
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-bottom: 1px dashed #2ac1ff;
        padding-bottom: 10px;
      }
      .titleLine_name{
        display: flex;
        align-items: center;
        .leftLine{
          display:inline-block;
          width:2px;
          height:15px;
          margin-right:10px;
          background: #2ac1ff;
        }
      }
      .closeBtn{
        width:20px;
        height:20px;
        background: url("../../../theme-default/src/img/close.png") no-repeat;
        background-size:20px;
      }
    }
    .middleOutLine{
      border-left:0.5px solid #2ac1ff;
      border-right:0.5px solid #2ac1ff;
      background:rgba(15,36,69,0.8);
    }
     .notisfy{
        display: flex;
        justify-content: flex-start;
        align-items: center;
        margin-left: 3%;
        font-size: 16px;
        margin-bottom:15px;
    }
    .topLine{
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding:0px 12px;
        div{
            font-size: 14px;
            color:#ffffff;
        }
    }
    .lookDetail{
        width: 110px;
	    height: 28px;
	    border: solid 1px #2ac1ff;
        color: #2bc2ff;
        font-size: 14px;
        text-align: center;
        line-height: 28px;
        margin-top:18px;
        margin-right: 10px;
        float:right;
    }
    .redLevel{
      color:#fb4d4e;
    }
    .yellowLevel{
      color:#fbda4e;
    }
}
</style>
